// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"DevelopmentBadge_componentStyle__vwgpM"};